<template>
  <el-dialog id="myDialog"
          :title="privaVideoObj.title"
          :fullscreen="true"
          :center="true"
          width="100%"
          custom-class="whd-video-dialog"
          :visible.sync="dialogVisible"
          @close="$emit('update:visible',false)">
          <video ref="videoPlayer" autoplay controls :src="privaVideoObj.url" @click.stop></video>
  </el-dialog>
</template>
<script>
  export default {
    name: "privaVideoObj",
    props: ["visible", "privaVideoObj"],
    watch: {
      visible() {
        this.dialogVisible = this.visible;
        if (this.video) {
          if (this.visible) {
            this.video.play()
          } else {
            this.video.pause()
          }
        }
      }
    },
    data() {
      return {
        dialogVisible: this.visible
      };
    },
    computed: {
      video() {
        return this.$refs.videoPlayer
      }
    },
    mounted() {
      let that = this
      document.getElementById("myDialog").addEventListener("click", function() {
        that.$emit('update:visible',false)
      })
    }
  };
</script>

